<template>
  <div
    class="rounded-3xl container"
    style="backdrop-filter: blur(8px) brightness(100%)"
  >
    <template v-if="productColorImages">
      <div class="mx-auto py-0 h-auto">
        <span
          class="relative top-10 right-6 z-10"
          @click="$emit('changeFavoriteProduct', product.id)"
        >
          <HeartIcon
            class="font-poppins font-medium fill-current cursor-pointer"
            :class="{
              'text-transparent': !product?.users_favorite?.length,
              'text-theme-9': product?.users_favorite?.length
            }"
            :style="{
              stroke: !product?.users_favorite?.length
                ? '#a13122'
                : 'currentColor'
            }"
          />
        </span>
        <TinySlider
          :options="{
            mode: 'gallery',
            controls: false,
            nav: true,
            speed: 500,
            autoplay: true
          }"
        >
          <div
            class="inline-grid flex-row-reverse lg:flex rounded-lg border shadow-lg pb-6 lg:pb-0 lg:px-32 px-6"
            style="
              border: 3px solid #ffffff47;
              width: 100%;
              margin: 0;
              border-radius: 20px;
              padding: 0;
            "
            v-for="(image, index) in productColorImages"
            :key="index"
          >
            <div
              class="w-full lg:p-4 pt-6"
              style="
                text-align: center;
                padding: 0;
                object-position: center;
                margin: 0;
              "
            >
              <img
                style="
                  position: relative;
                  width: 100%;
                  text-align: center;
                  height: 400px;
                  margin: 0;
                  padding: 0;
                  object-position: center;
                  object-fit: contain;
                "
                :src="image"
                alt="Imagen del producto del color seleccionado"
                class=""
                crossorigin="anonymous"
              />
            </div>
          </div>
        </TinySlider>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      productColorImages: undefined
    }
  },
  props: {
    productColor: {
      type: Object
    },
    product: {
      type: Object
    }
  },
  emits: ['update:productColor', 'changeFavoriteProduct'],
  beforeMount() {
    if (this.productColor?.images?.length) {
      this.productColorImages = this.productColor?.images
    } else if (this.product?.sku !== 'COTESPI001') {
      this.productColorImages = [require('@/assets/images/product.svg')]
    } else {
      this.productColorImages = [require('@/assets/images/COTESPI001.svg')]
    }
  },
  watch: {
    productColor: {
      handler(val) {
        this.productColorImages = undefined
        setTimeout(() => {
          this.productColorImages = val?.images
        })
      },
      deep: true
    }
  }
}
</script>
